import request from '@/util/request';

//获取设备维保记录
export const deviceKeepRecordList = (params, options) =>
request.get('/api/upkeeptasklist/upkeepPage', Object.assign({}, options, { params }));

//新增设备维保记录
export const saveKeepRecord = (params) =>
request.post('/api/upkeeptasklist/upkeepSave',params);

//根据设备id查询巡检标准
export const getkeepStandard = (params, options) =>
request.get('/api/upkeeptasklist/upkeepStandardByDevice', Object.assign({}, options, { params }));

//查看
export const getDetail = (id) =>
request.get('/api/upkeeptasklist/upkeepDetail?id='+id);

//编辑
export const updateKeepDetail = (params) =>
request.post('/api/upkeeptasklist/upkeepUpdate',params);

//删除
export const deleteKeepDetail = (id) =>
request.post('/api/upkeeptasklist/upkeepRemove?ids='+id);